import toObject from "@/store/utils/to-object";
import { has } from "lodash";

const MAP_TYPE = "MapItem"
export function setFetchingState(state) {
  state.isFetching = true;
  state.isErrored = false;
  state.error = {};
}

export function setFilterType(state, filterType = "mine") {
  state.filterType = filterType;
}
export function setFilterKeyword(state, filterKeyword = "") {
  state.filterKeyword = filterKeyword;
}
export function setPagination(state, page = 1) {
  state.page = page;
  state.numPages =
    Math.ceil(state.metadata.total_entries / state.resultsPerPage) || 1;
}

export function setOrder(DEFAULT_VALUES) {
  return function (state, orderOptions) {
    state.order = orderOptions.order || DEFAULT_VALUES.order;
    state.orderDirection =
      orderOptions.direction || DEFAULT_VALUES.orderDirection;
  };
}

export function setResultsPerPage(state, resultsPerPage = 12) {
  state.resultsPerPage = resultsPerPage;
}

export function setQueryFilter(state, query) {
  state.queryFilter = query;
}

export function setRequestError(state, error) {
  state.isFetching = false;
  state.isErrored = true;
  state.error = error;
}

export function setVisualizations(state, visualizationsData) {
  state.list = toObject(visualizationsData.visualizations, "id");
  state.metadata = {
    total_entries: visualizationsData.total_entries,
  };
  //取到的数据是否已添加到球上了
  const existIds = Object.keys(state.addedList)
  for (const id of existIds) {
    if (state.list[id]) {
      state.list[id].added_to_map = true
    }
  }

  state.isFetching = false;
}

//设置地图图层
export function setMapLaysers(state, { visID, layers }) {
  const isVisualizationPresent = has(
    state.list,
    visID
  );

  if (isVisualizationPresent) {
    Object.assign(state.list[visID], { layers });
  }
}

//设置地图是否可见
export function toggleMapVisible(state, { mapId, visible }) {
  const map = state.orderList.find(m => m.id == mapId);
  if (map) {
    map.visible = visible
  }
}


//设置图层是否可见
export function toggleMapLayserVisible(state, { visId, layerId, visible }) {
  const isVisualizationPresent = has(
    state.addedList,
    visId
  );

  if (isVisualizationPresent) {
    const layers = state.addedList[visId].layers;
    const layer = layers.find((l) => l.id === layerId);
    layer.options.visible = visible;
  }
}

export function addToEarth(state, visId) {
  const isVisualizationPresent = has(
    state.list,
    visId
  );
  if (isVisualizationPresent) {
    const vis = JSON.parse(JSON.stringify(state.list[visId]))
    vis.addedTime = Date.now()
    vis.mapType = MAP_TYPE
    state.addedList[visId] = vis
  }
}

export function addToOrderList(state, vis) {
  state.orderList.unshift(vis)
}

export function removeFromEarth(state, visId) {
  const isVisualizationPresent = has(
    state.addedList,
    visId
  );
  if (isVisualizationPresent) {
    delete state.addedList[visId]
  }
}

export function removeVis(state, visData) {
  const isVisualizationPresent = has(
    state.list,
    visData.id
  );
  if (isVisualizationPresent) {
    delete state.list[visData.id]
  }
}

export function removeFromOrderList(state, visId) {
  const indexInOrderList = state.orderList.findIndex(v => v.id === visId)
  if (indexInOrderList >= 0) {
    state.orderList.splice(indexInOrderList, 1)
  }
}

export function setOrderList(state, newList) {
  state.orderList = newList
}

export function updateVisualization(
  state,
  { visualizationId, visualizationAttributes }
) {
  const isVisualizationPresent = has(
    state.list,
    visualizationId
  );

  if (isVisualizationPresent) {
    Object.assign(state.list[visualizationId], visualizationAttributes);
  }
}
